import { defaultButton, defaultDescription, defaultId, defaultStatus, defaultStatusMsg, defaultStyle, defaultTime, defaultType } from "./shared.js";
import { convertToDate } from "../shared/miscUtils.js";
import { getLanguage } from "../../config/language/language";

// Custom functions for table columns.
const clickButton = (props, params) => {
    const cmd = params.row.status === "PROCESSED" ? "view" : "edit";
    props.browser.navigate(`/database/transcripts/${params.row.id}/${cmd}`);
};

const createTitle = (props, params) => {
    return params.row.status === "PROCESSED" ? "View" : "Edit";
};

const disableButton = (props, params) => {
    return ["RECREATE", "AWAITING_CLEANUP", "IN_PROGRESS"].includes(params.row.status);
};

// Column definitions.
const resourceId = {
    ...defaultStyle,
    field: "resource_id",
    headerName: "Resource ID",
    type: "number",
    minWidth: 90
};
const resource = (props) => ({
    ...defaultStyle,
    field: "resource.name",
    headerName: "Resource",
    flex: 0.2,
    minWidth: 175,
    valueGetter: (params) => params.row.resource?.name || (props?.backend?.resources?.data?.find((r) => r.id === params.row.resource_id) || {})?.name || "N/A"
});
const description = {
    ...defaultDescription,
    field: "resource.description",
    minWidth: 200,
    valueGetter: (params) => params.row.resource?.description || ""
};
const library = {
    ...defaultStyle,
    field: "resource.library.name",
    headerName: "Library",
    flex: 0.12,
    minWidth: 120,
    valueGetter: (params) => params.row.resource?.library?.name || ""
};
const type = {
    ...defaultType,
    field: "resource.type",
    valueGetter: (params) => params.row.resource?.type
};
const authors = {
    ...defaultStyle,
    field: "resource.authors",
    headerName: "Authors",
    flex: 0.12,
    minWidth: 120,
    filterable: false,
    sortable: false,
    valueGetter: (params) => (params.row.resource?.authors || []).map((a) => `${a.first_name} ${a.last_name}`.trim()).filter(Boolean).join(", ")
};
const uploadedOn = {
    ...defaultTime("uploaded_on"),
    field: "resource.uploaded_on",
    headerName: "Uploaded on",
    valueGetter: (params) => convertToDate(params.row.resource?.uploaded_on)
};
const text = { ...defaultStyle, field: "text", headerName: "Transcript", flex: 0.25, minWidth: 200 };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const status = { ...defaultStatus() };
const captionSource = {
    ...defaultStyle,
    field: "caption_source",
    headerName: getLanguage().TRANSCRIPT_CAPTION_SOURCE,
    minWidth: 150
};
const llmCleaned = {
    ...defaultStyle,
    field: "llm_cleaned",
    headerName: getLanguage().TRANSCRIPT_LLM_CLEANED,
    minWidth: 120,
    valueGetter: (params) => {
        if (params.row.llm_cleaned === true) return getLanguage().TRANSCRIPT_LLM_CLEANED_YES;
        if (params.row.llm_cleaned === false) return getLanguage().TRANSCRIPT_LLM_CLEANED_NO;
        return "";
    }
};
const statusMsg = { ...defaultStatusMsg };
const action = (props) => {
    return { ...defaultButton(props, { onClick: clickButton, disabled: disableButton, title: createTitle }), minWidth: 100, flex: 0.1 };
};

// Table columns.
export const columns = (props) => [defaultId, resourceId, resource(props), description, library, type, authors, text, status, captionSource, llmCleaned, uploadedOn, createdOn, updatedOn, statusMsg, action(props)];

export const transcriptColumnVisibility = {
    "resource.authors": false,
    "resource.uploaded_on": false,
    resource_id: false,
    caption_source: false,
    llm_cleaned: false
};

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
